import { render, staticRenderFns } from "./tidypay.vue?vue&type=template&id=7399a81f"
import script from "./tidypay.vue?vue&type=script&lang=js"
export * from "./tidypay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports